import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { getCoachWorkExceptions, patchCoachWorkExceptions } from './api';
import { coachWorkExceptionKeys } from './keys';
import { PatchCoachWorkExceptionBody } from './types';

export const useCoachWorkExceptions = ({
    centerId,
    year,
    month,
    enabled = true,
}: {
    centerId: string;
    year: string;
    month: string;
    enabled?: boolean;
}) =>
    useQuery({
        queryKey: coachWorkExceptionKeys.list(centerId, year, month),
        queryFn: () => getCoachWorkExceptions({ centerId, year, month }),
        enabled: enabled && !!centerId,
        select: (data) => data?.data,
    });

export const usePatchCoachWorkExceptions = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({
            centerId,
            body,
        }: {
            centerId: string;
            body: PatchCoachWorkExceptionBody;
        }) => patchCoachWorkExceptions({ centerId, body }),
        onSuccess: (_, variables) => {
            queryClient.invalidateQueries({
                queryKey: coachWorkExceptionKeys.list(
                    variables.centerId,
                    variables.body.year,
                    variables.body.month,
                ),
            });
        },
    });
};
